import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ImageLabel } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { Icon, Stack, TextAlpha } from '@yonderland/andes-react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { getPictureSrcset } from '../util/ImageUtil';
import MiniPDPMultiContainer from './MiniPDPMultiContainer';
const ShopTheLookContainer = ({ images, cdnSettings, products, imageLabel, miniPdpTitle, mainWebshopId, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { imageCdnPrefix } = useAemConfig();
    const [isOpenMiniPDP, setIsOpenMiniPDP] = useState(false);
    const dispatch = useDispatch();
    const defaultImage = useMemo(() => images.find(image => image.isDefault) || images[0], [images]);
    const extensiveCarouselImages = images.map(image => image.image);
    const defaultImageSrcset = getPictureSrcset(defaultImage.image, imageCdnPrefix, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.imageQuality, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.requestPassThrough);
    const onMiniPDPClose = () => setIsOpenMiniPDP(false);
    const openMiniPDP = () => {
        const image = defaultImage.image.imagePath.split('/');
        dispatch(analyticsActions.shopTheLookOpened(image[image.length - 1]));
        setIsOpenMiniPDP(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(ImageLabel, { image: { src: defaultImage.image.imagePath, srcset: defaultImageSrcset, isPicture: true }, label: _jsxs(Stack, { gap: "3", children: [_jsx(TextAlpha, { as: "span", variant: "bodyS", color: "current", children: imageLabel || t('product.look.title') }), _jsx(Icon, { source: CaretRightIcon, size: "sm" })] }), onClick: openMiniPDP }), _jsx(MiniPDPMultiContainer, { isOpen: isOpenMiniPDP, onClose: onMiniPDPClose, productIds: products, extensiveCarouselImages: extensiveCarouselImages, cdnSettings: cdnSettings, popoverTitle: miniPdpTitle, mainWebshopId: mainWebshopId })] }));
};
export default ShopTheLookContainer;
